module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error403-portrait_3e3cb95.png";